import {FirestoreBase} from "./FirestoreBase";


export class BeerType extends FirestoreBase {

  name?: string;
  picklistName?: string;
  brewersAssociation?: string;
  description?: string;
  links?: {[key: string]: string};

  validate() {
    if (!super.validate()) {
      return false;
    }
    if (this.name == null || this.name === "") {
      return false;
    }
    if (this.picklistName == null || this.picklistName === "") {
      return false;
    }
    if (this.brewersAssociation == null || this.brewersAssociation === "") {
      return false;
    }
    return true;
  }
}
